var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-view-style",class:[{'no-show':!_vm.$root.token}],style:({
    'background-color': _vm.$store.state.corpInfo.darkTheme?'black':'#EEEEEE'
  })},[(_vm.$root.token)?_c('div',[_c('UserTransactions',{ref:"UserTransactions",staticClass:"pa-0",attrs:{"currentTab":0}})],1):_c('div',{staticClass:"no-found-style"},[_c('NotFound')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }